import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=67bf3533"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bf3533')) {
      api.createRecord('67bf3533', component.options)
    } else {
      api.reload('67bf3533', component.options)
    }
    module.hot.accept("./Maintenance.vue?vue&type=template&id=67bf3533", function () {
      api.rerender('67bf3533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/Maintenance.vue"
export default component.exports